import { USER_LANGUAGES } from '../../../services/languageService.js';

export function getLanguages() {
  return USER_LANGUAGES.map(({ key = '', value = '' }) => {
    return {
      value: key.toUpperCase(),
      text: value,
    };
  });
}
